import { Link } from "react-router-dom";
import { DISCLAIMER_TEXT } from "@/lib/constants";

export default function Footer() {
  return (
    <footer className="border-t border-white/[0.08] bg-[#0A0B0E] mt-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="kicker">PFAS Risk Intelligence</div>
          <div className="mt-3 font-display text-2xl leading-tight max-w-md">
            Find the risk. Trace the source. Recommend the next move.
          </div>
          <p className="mt-6 text-sm text-white/60 max-w-md leading-relaxed" data-testid="footer-description">
            Desk-based PFAS risk intelligence for developers, landowners, planning professionals,
            environmental advisers, legal teams, lenders and insurers.
          </p>
        </div>
        <div>
          <div className="kicker mb-4">Product</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/triage" className="text-white/70 hover:text-white" data-testid="footer-triage">PFAS Risk Triage Tool</Link></li>
            <li><Link to="/checklist" className="text-white/70 hover:text-white" data-testid="footer-checklist">Free Risk Checklist</Link></li>
            <li><Link to="/risk-screen" className="text-white/70 hover:text-white" data-testid="footer-risk-screen">PFAS Brownfield Risk Screen</Link></li>
            <li><Link to="/portfolio-screening" className="text-white/70 hover:text-white" data-testid="footer-portfolio">Portfolio Screening</Link></li>
            <li><Link to="/risk-watch" className="text-white/70 hover:text-white" data-testid="footer-risk-watch">PFAS Risk Watch</Link></li>
          </ul>
        </div>
        <div>
          <div className="kicker mb-4">Contact</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li>pfasriskintelligence.co.uk</li>
            <li>info@pfasriskintelligence.co.uk</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/[0.06]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-[11px] text-white/40 max-w-3xl leading-relaxed" data-testid="footer-disclaimer-text">
            {DISCLAIMER_TEXT}
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <Link to="/privacy" className="text-[11px] text-white/50 hover:text-white font-mono-alt tracking-[0.14em] uppercase" data-testid="footer-privacy">Privacy</Link>
            <Link to="/terms" className="text-[11px] text-white/50 hover:text-white font-mono-alt tracking-[0.14em] uppercase" data-testid="footer-terms">Terms</Link>
            <Link to="/disclaimer" className="text-[11px] text-white/50 hover:text-white font-mono-alt tracking-[0.14em] uppercase" data-testid="footer-disclaimer">Disclaimer</Link>
            <div className="text-[11px] text-white/40 font-mono-alt tracking-[0.14em] uppercase">© {new Date().getFullYear()} PFAS Risk Intelligence</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
